import { usePlanningFormTranslation } from '@libs/utils/translations'

import { getLabelFormatted } from '../utils/getLabelFormatted'

export const useDefaultLabel = () => {
  const { t } = usePlanningFormTranslation()
  return getLabelFormatted({
    label: t('realHoursForm.noLabel')
  })
}
